import axios from "axios";

export const axiosClientCMS = axios.create({
  baseURL: typeof window === "undefined" ? process.env.CMS_API_URL : "/cms-api",
});

export const axiosClient = axios.create({
  baseURL: "/api",
});
